import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Hooks } from '@grandvisionhq/carts-v2';
import { useLocation } from '@grandvisionhq/frk-routing';
import { updateActiveVariant } from '../../../../context/actions.js';
import '../../../../context/reducer.js';
import { useProductData } from '../../../../context/product-context-hooks.js';
import '../../../../context/ProductContext.js';
import '../../../../context/CmsContext.js';
import { PackageQuantityDropdown } from './PackageQuantityDropdown.js';

var PackageQuantityDropdownContainer = (_param)=>{
    var { onChange  } = _param, props = swcHelpers.objectWithoutProperties(_param, [
        "onChange"
    ]);
    const { dispatch , product , activeVariant  } = useProductData();
    const formatter = Hooks.useGetProductLinkFormatter();
    const { query  } = useLocation();
    const handleChange = (item)=>{
        const queryParams = [
            ...query
        ].length > 0 ? query : undefined;
        const productLink = formatter(activeVariant.slug, item.value, product.productType, queryParams);
        dispatch(updateActiveVariant({
            sku: item.value
        }));
        window.history.replaceState(null, '', productLink);
        onChange(item);
    };
    return /*#__PURE__*/ React.createElement(PackageQuantityDropdown, swcHelpers.extends({}, props, {
        onChange: handleChange
    }));
};

export { PackageQuantityDropdownContainer };
//# sourceMappingURL=PackageQuantityDropdownContainer.js.map
